'use client';
/* External Imports */
import {
  Accordion,
  AccordionButton,
  AccordionIcon,
  AccordionItem,
  AccordionPanel,
  Box,
  chakra,
  Divider,
} from '@chakra-ui/react';
import parser from 'html-react-parser';

/**
 * Renders the Faq content component
 *
 * @param {object} sectionContent - Data for section
 * @returns {ReactElement} Faq content component
 */
const KshetraFaq = ({ sectionContent }) => {
  if (!sectionContent || typeof sectionContent !== 'object') {
    return <Box color="white">No content available</Box>;
  }

  const { title, faqs } = sectionContent;

  return (
    <Box
      as="div"
      color="#FFFFFF"
      width={{ base: '85%', md: '80%', xl: '1000px' }}
      m={{ base: '10px auto', md: '30px auto' }}
    >
      {title?.length > 0 && (
        <Accordion allowMultiple m="5px auto" width="100%">
          <AccordionItem border="none">
            <AccordionButton
              fontFamily="FedraSerifDisplayRegular"
              lineHeight={{ lg: '31.2px' }}
              fontWeight="400"
              fontSize={{ base: '20px', md: '24px' }}
              pt="4"
              pb="4"
              _focus={{ shadow: 'transparent' }}
              _hover={{ backgroundColor: '#162E9A' }}
              bg="#162E9A"
            >
              <chakra.div flex="1" textAlign="left" color="#FFFFFF">
                {title[0]?.faqTitle || 'Untitled Section'}
              </chakra.div>
              <AccordionIcon width={"24.79px"} height={"27.29px"}/>
            </AccordionButton>
            <AccordionPanel pb="1">
              {faqs?.map((faq, index) => (
                <AccordionItem
                  key={index}
                  border="none"
                  borderBottom="1px solid #FFFFFF8A"
                >
                  <AccordionButton
                    p="20px 0"
                    fontSize={{ base: '16px', md: '18px' }}
                    fontWeight="600"
                    fontFamily="FedraSansStd-book, sans-serif"
                    lineHeight={{ base: '20.8px', md: '23.4px' }}
                    _hover={{ background: 'none' }}
                    _focus={{ shadow: 'transparent' }}
                    color="#FFFFFF"
                  >
                    <chakra.div flex="1" textAlign="left" fontWeight="600">
                      {faq?.question || 'No question provided'}
                    </chakra.div>
                    <AccordionIcon width={"24.79px"} height={"27.29px"}/>
                  </AccordionButton>
                  <AccordionPanel
                    pb={{ base: '15px', md: '30px' }}
                    pt={{ base: '0px', md: '8px' }}
                    fontFamily="FedraSansStd-book, sans-serif"
                    fontSize={{ base: '16px', md: '18px' }}
                    lineHeight={{ base: '22.4px', md: '22.4px' }}
                    pl="0"
                    color="#FFFFFF"
                  >
                    {faq?.answer ? parser(faq.answer) : 'No answer provided'}
                  </AccordionPanel>
                </AccordionItem>
              ))}
            </AccordionPanel>
          </AccordionItem>
        </Accordion>
      )}
      <style global jsx>
        {`
          .sannidhi_faq p span {
            font-family: FedraSansStd-book, sans-serif !important;
            font-size: 14px !important;
            line-height: 22px !important;
          }
        `}
      </style>
    </Box>
  );
};

export default KshetraFaq;